import { apiClient } from './client';

export interface Pair {
  id: number;
  player1_id: string;
  player2_id?: string;
  status: 'pending' | 'active' | 'dissolved';
  created_at: string;
  dissolved_at?: string;
  player1?: { id: string; first_name: string; last_name: string; photo_url?: string };
  player2?: { id: string; first_name: string; last_name: string; photo_url?: string };
}

export interface PairCreate {
  player2_email: string;
}

export interface PairInvitation {
  id: number;
  inviter_name: string;
  created_at: string;
}

export const pairsApi = {
  create: (data: PairCreate) => apiClient.post<Pair>('/api/pairs', data),
  listMine: () => apiClient.get<Pair[]>('/api/pairs/me'),
  get: (id: number) => apiClient.get<Pair>(`/api/pairs/${id}`),
  dissolve: (id: number) => apiClient.delete(`/api/pairs/${id}`),
  getMyInvitations: () => apiClient.get<PairInvitation[]>('/api/pairs/invitations/me'),
  accept: (pairId: number) => apiClient.post(`/api/pairs/${pairId}/accept`),
  decline: (pairId: number) => apiClient.post(`/api/pairs/${pairId}/decline`),
};
